import React from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { PainPointsSection } from '../components/landing/PainPointsSection';
import { SolutionSection } from '../components/landing/SolutionSection';
import { HowItWorksSection } from '../components/landing/HowItWorksSection';
import { ProgramSection } from '../components/landing/ProgramSection';
import { TestimonialsSection } from '../components/landing/TestimonialsSection';
import { ForWhoSection } from '../components/landing/ForWhoSection';
import { PricingSection } from '../components/landing/PricingSection';
import { FAQSection } from '../components/landing/FAQSection';
import { TermsFooter } from '../components/landing/TermsFooter';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-x-hidden selection:bg-sage-light/50 selection:text-charcoal" data-id="element-266">
      <HeroSection data-id="element-267" />
      <PainPointsSection data-id="element-268" />
      <SolutionSection data-id="element-269" />
      <HowItWorksSection data-id="element-270" />
      <ProgramSection data-id="element-271" />
      <TestimonialsSection data-id="element-272" />
      <ForWhoSection data-id="element-273" />
      <PricingSection data-id="element-274" />
      <FAQSection data-id="element-275" />
      <TermsFooter data-id="element-276" />
    </main>;
}